import { createContainer } from 'react-sweet-state';

import {
  type Actions,
  type ContainerProps,
  type State,
  TalkingPointsStore,
} from './TalkingPointsStore';

export const TalkingPointsStoreContainer = createContainer<State, Actions, ContainerProps>(
  TalkingPointsStore,
  {
    onInit:
      () =>
      ({ setState }, { state }) => {
        if (state) {
          setState(state);
        }
      },
    onUpdate:
      () =>
      ({ setState }, { state }) => {
        if (state) {
          setState(state);
        }
      },
  }
);
